import { PersonProfileService } from '@openeducation/oe-it-services';
import type { PersonProfileLite } from '@openeducation/oe-it-shared-types';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../../environment/environment.provider';

export interface UseLiveClassFeedbackProps {
  studentId?: number;
}
export const useStudentProfileLite = ({
  studentId,
}: UseLiveClassFeedbackProps) => {
  const { environment } = useEnvironmentContext();

  const {
    data: studentProfile,
    isLoading: isLoadingStudentProfile,
    isError: isErrorStudentProfile,
  } = useQuery<PersonProfileLite>(
    ['studentProfileLite', studentId],
    () =>
      PersonProfileService.getLiteProfileTeacherById(environment, studentId),
    {
      enabled: !!studentId,
    }
  );

  return {
    studentProfile,
    isLoadingStudentProfile,
    isErrorStudentProfile,
    countryCode: studentProfile?.countryCode,
  };
};
